import { useSearchParams } from "react-router-dom";
import { MapPin, Phone, Mail, Globe, ExternalLink } from "lucide-react";
import { Reveal, PageHero, SectionHead, usePageMeta } from "../components/ui-bits";
import { IMG, company } from "../data/content";
import EnquiryForm from "../components/EnquiryForm";

import { useCmsSingleton } from "../hooks/useCmsContent";

const Contact = () => {
  const cmsContact = useCmsSingleton("contact", {});
  const co = {
    ...company,
    phone: cmsContact.phone || company.phone,
    email: cmsContact.email || company.email,
    domain: cmsContact.domain || company.domain,
    address: (cmsContact.address_office || []).length ? cmsContact.address_office : company.address,
  };
  const digits = co.phone.replace(/[^\d+]/g, "");
  const mapsUrl = cmsContact.maps_url || "https://www.google.com/maps/search/?api=1&query=Poonam+Chambers+Dr+Annie+Besant+Road+Worli+Mumbai+400018";
  usePageMeta(
    "Contact Us — G. R. Engineering Private Limited | Mumbai",
    "Contact G. R. Engineering Private Limited: 202/A Poonam Chambers, Dr. Annie Besant Road, Worli, Mumbai 400 018. Phone +91 22 2496 0551~55, email sales@grengg.com."
  );
  const [params] = useSearchParams();
  const interest = params.get("interest") || "General Enquiry";

  return (
    <>
      <PageHero
        img={IMG("opal-c4")}
        eyebrow="Contact"
        title="Talk to our engineering team"
        sub="Share your fabrication requirement, EPC project or site fabrication scope — we respond with engineering, not just a brochure."
      />
      <section className="bg-slate-50" data-testid="contact-section">
        <div className="container-gre py-20 lg:py-28 grid lg:grid-cols-5 gap-12 lg:gap-16">
          <div className="lg:col-span-3 bg-white border border-slate-200 p-8 lg:p-12">
            <SectionHead eyebrow="Enquire Now" title="Send us your requirement" />
            <div className="mt-10">
              <EnquiryForm defaultInterest={interest} />
            </div>
          </div>
          <div className="lg:col-span-2 space-y-6">
            <Reveal>
              <div className="bg-[#0A1128] text-white p-8 lg:p-9" data-testid="contact-details-card">
                <p className="font-mono-tech text-[10px] font-bold uppercase tracking-[0.25em] text-red-400">Registered / Head Office</p>
                <p className="mt-4 font-display text-lg font-bold">{co.name}</p>
                <ul className="mt-6 space-y-4 text-sm">
                  <li className="flex gap-3"><MapPin size={16} className="text-[#E8574F] shrink-0 mt-0.5" /><span className="text-slate-300">{co.address.map((l) => <span key={l} className="block">{l}</span>)}</span></li>
                  <li><a href={`tel:${digits}`} className="flex gap-3 hover:text-white transition-colors duration-200" data-testid="contact-phone-link"><Phone size={16} className="text-[#E8574F] shrink-0 mt-0.5" />{co.phone}</a></li>
                  <li><a href={`mailto:${co.email}`} className="flex gap-3 hover:text-white transition-colors duration-200" data-testid="contact-email-link"><Mail size={16} className="text-[#E8574F] shrink-0 mt-0.5" />{co.email}</a></li>
                  <li className="flex gap-3"><Globe size={16} className="text-[#E8574F] shrink-0 mt-0.5" />{co.domain}</li>
                </ul>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <a
                href={mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block h-56 overflow-hidden border border-slate-200 bg-[#0A1128]"
                data-testid="contact-map-link"
              >
                <div className="absolute inset-0 blueprint-grid" />
                <div className="absolute inset-0 flex flex-col items-center justify-center text-white">
                  <MapPin size={30} className="text-[#C5221F]" />
                  <p className="mt-3 font-display text-sm font-bold">Poonam Chambers, Worli, Mumbai</p>
                  <p className="mt-1.5 inline-flex items-center gap-1.5 text-xs text-slate-400 group-hover:text-white transition-colors duration-200">
                    Open in Google Maps <ExternalLink size={12} />
                  </p>
                </div>
              </a>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
